import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'

import {
  Container,
  Segment,
  Dimmer,
  Loader,
  Menu,
  Icon,
  Label
} from 'semantic-ui-react'

import {
  escapeRE,
  getPageData
} from '_utils'

import Pagination from '_views/pagination'
import AutoComplete from '_views/autocomplete'
import SuggestionItem from '_views/suggestionItem'
import SuggestionItems from '_views/suggestionItems'

import ResellerItem from './reseller'
import AddResellerModal from './addReseller'
import useCanAdminLicenses from '../../hooks/useCanAdminLicenses'

const getNote = R.prop('note')
const getNotes = R.compose(
  R.defaultTo([]),
  R.prop('notes')
)
const getInvoiceNumber = R.prop('invoice_number')
const getInvoices = R.compose(
  R.defaultTo([]),
  R.prop('invoices')
)

const refreshListWithProps = props => () => props.onRefreshList(R.pathOr({}, ['navigation'], props.resellersPage))
const formatSelection = reseller => {
  const _id = R.prop('_id', reseller)
  const name = R.prop('name', reseller)
  const contactEmail = R.prop('contact_email', reseller)
  const contactName = R.prop('contact_name', reseller)
  return (
    <Label style={{display: 'inline-block'}} key={'sel_' + _id}>
      <div>{ name }</div>
      <div>{ contactName }</div>
      <div>{ contactEmail }</div>
      <div><small>{ _id }</small></div>
    </Label>
  )
}

const formatSuggestion = (reseller, term) => {
  const tReg = {
    regex: new RegExp(escapeRE(term), 'i'),
    term
  }
  return (
    <div key={'sug_' + reseller._id} >
      <SuggestionItem label='name' text={reseller.name} tReg={tReg} always={true} />
      <SuggestionItem label='id' text={reseller._id} tReg={tReg} />
      <SuggestionItem label='contact name' text={reseller.contact_name} tReg={tReg} always={true} />
      <SuggestionItem label='contact email' text={reseller.contact_email} tReg={tReg} />
      <SuggestionItem label='xero id' text={reseller.xero_id} tReg={tReg} />
      <SuggestionItem label='capsule id' text={reseller.capsule_id} tReg={tReg} />
      <SuggestionItem label='netsuite id' text={reseller.netsuite_id} tReg={tReg} />
      <SuggestionItem label='description' text={reseller.description} tReg={tReg} />
      <SuggestionItems label='note' pathFn={getNote} list={getNotes(reseller)} tReg={tReg} />
      <SuggestionItems label='invoice' pathFn={getInvoiceNumber} list={getInvoices(reseller)} tReg={tReg} />
    </div>
  )
}

const displayNone = {display: 'none'}

const Resellers = props => {
  const {
    items,
    request,
    total,
    pageNum,
    perPage,
    autocomplete
  } = getPageData([], props.resellersPage)
  const canAdminLicenses = useCanAdminLicenses();

  return (
    <Container textAlign='left' fluid style={props.display ? {} : displayNone} >
      <Menu icon='labeled' secondary size='small'>
        <Menu.Menu position='left'>
          <Menu.Item fitted header style={{ maxWidth: "100%" }}>
            <AutoComplete
              minWidth={300}
              icon='users'
              placeholder='Search resellers...'

              uniqField='_id'
              isLoading={autocomplete.isLoading}
              total={autocomplete.total}
              pageNum={autocomplete.pageNum}
              selections={autocomplete.selections}
              suggestions={autocomplete.suggestions}

              onTermChange={props.onTermChange}
              onSelectionChange={props.onSelectionChange}
              onClearSuggestions={props.onClearSuggestions}
              formatSelection={ formatSelection }
              formatSuggestion={ formatSuggestion }
            />
          </Menu.Item>
        </Menu.Menu>
        <Menu.Menu position='right'>
          <Menu.Item name='refresh' onClick={refreshListWithProps(props)} >
            <Icon name='refresh' />
            Refresh
          </Menu.Item>
          { canAdminLicenses ? <AddResellerModal onCreate={props.onCreateReseller} /> : null }
        </Menu.Menu>
      </Menu>

      <Pagination
        goToPage={props.goToPage}
        pageNum={pageNum}
        perPage={perPage}
        total={total}
      />
      <Segment basic>
        <Dimmer inverted active={request.isLoading === true}>
          <Loader />
        </Dimmer>
        {items.map(i => <ResellerItem
          key={i._id}
          reseller={i}
          isLoading={request.isLoading === i._id}

          pageNum={pageNum}
          perPage={perPage}

          onDeactivateReseller={props.onDeactivateReseller}
          onRemoveReseller={props.onRemoveReseller}
          onRefreshReseller={props.onRefreshReseller}
          onRefreshList={refreshListWithProps(props)}
          onModifyOne={props.onModifyOne}
          onAddNote={props.onAddNote}
          onRemoveNote={props.onRemoveNote}

          acFuncs={props.acFuncs}
          acData={props.getAcData(i._id)}

        />) }
      </Segment>
    </Container>
  )
}

Resellers.propTypes = {
  display: PropTypes.bool.isRequired,
  // mapStateToProps
  resellersPage: PropTypes.object.isRequired,
  getAcData: PropTypes.func.isRequired,
  // mapDispatchToProps
  onRefreshReseller: PropTypes.func.isRequired,
  onRemoveReseller: PropTypes.func.isRequired,
  onDeactivateReseller: PropTypes.func.isRequired,
  onModifyOne: PropTypes.func.isRequired,
  onAddNote: PropTypes.func.isRequired,
  onRemoveNote: PropTypes.func.isRequired,
  goToPage: PropTypes.func.isRequired,
  onRefreshList: PropTypes.func.isRequired,
  onCreateReseller: PropTypes.func.isRequired,

  onTermChange: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  onClearSuggestions: PropTypes.func.isRequired,

  acFuncs: PropTypes.object.isRequired
}

export default Resellers



// WEBPACK FOOTER //
// ./webAdmin/components/resellers/page.js